<template>
  <div style="height:100%;margin:0px;padding:0px">
    <a-layout style="height:100%;margin:0px;padding:0px">
      <a-layout-sider>
        <a-menu
          mode="inline"
          @click="handleClick"
          :openKeys="openKeys"
          @openChange="onOpenChange"
          style="width: 200px;height:100%"
        >
          <a-sub-menu key="sub4">
            <span slot="title">
              <a-icon type="setting" /><span>稍后处理 5</span
              ><a-badge :count="this.waitCount" style="margin-left:10px" />
            </span>
            <a-menu-item key="9">Option 9</a-menu-item>
            <a-menu-item key="10">Option 10</a-menu-item>
            <a-menu-item key="11">Option 11</a-menu-item>
            <a-menu-item key="12">Option 12</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub1">
            <span slot="title">
              <a-icon type="mail" />
              <span>待处理 20</span>
            </span>
            <a-menu-item key="1">Option 1</a-menu-item>
            <a-menu-item key="2">Option 2</a-menu-item>
            <a-menu-item key="3">Option 3</a-menu-item>
            <a-menu-item key="4">Option 4</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2">
            <span slot="title"
              ><a-icon type="appstore" /><span>已处理 10</span></span
            >
            <a-menu-item key="5">Option 5</a-menu-item>
            <a-menu-item key="6">Option 6</a-menu-item>
          </a-sub-menu>
        </a-menu>
        <a-affix :offsetBottom="10">
          <a-button type="primary" style="margin-left:40px"
            >添加呼叫资源</a-button
          >
        </a-affix>
      </a-layout-sider>
      <a-layout-content>
        <div style="height:100%;">
          <CallInfo></CallInfo>
        </div>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import CallInfo from '@/components/Call-Work-Info.vue'

export default {
  data () {
    return {
      rootSubmenuKeys: ['sub1', 'sub2', 'sub4'],
      openKeys: ['sub1'],
      waitCount: 0
    }
  },
  components: {
    CallInfo
  },
  methods: {
    handleClick (e) {
      CallInfo.addN('123ss')
      console.log('click', e, e.key)
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }
  },
  watch: {
    openKeys (val) {
      console.log('openKeys', val)
    }
  }

}
</script>
